/**
 * Muestra en consola un mensaje con el texto coloreado.
 * @param {string} text  — El mensaje a loguear.
 * @param {string} color — Cualquier valor válido de CSS color (ej. "#888", "red", "rgba(0,0,0,0.5)").
 */
export function styledLog(text, color = 'inherit') {
    // %c marca el inicio de estilo CSS para la siguiente parte de texto
    const formatString = `%c${text}`;
    const css       = `color: ${color};`;
    console.log(formatString, css);
  }